import styles from './SearchTray.module.css';

/** Shown when the FTS returns zero matches across all three groups. */
export function SearchEmptyState({ query }: { query: string }) {
  return (
    <div className={styles.emptyState} role="status" aria-live="polite">
      <p className={styles.emptyStateTitle}>No matches for &ldquo;{query}&rdquo;</p>
      <p className={styles.emptyStateBody}>
        Try a shorter query or different keywords.
      </p>
    </div>
  );
}
